export default __webpack_public_path__ + "static/media/icon-community.2de0fe7f.svg";